import { useLocale as useLocaleR42 } from '@/lib/locale';
import React from 'react';
import { Link } from 'react-router-dom';

/**
 * LegalFooter
 * -----------
 * Small bottom-of-page footer with operator info + Privacy/Terms links.
 * Rendered on Landing, Login, Signup, and CoachPublic pages so the legal
 * docs are always reachable per common privacy-law guidance (the
 * "clear and conspicuous" requirement under CCPA/CPRA, etc.).
 */
export function LegalFooter({ variant = 'light' }) {
    const { t: t42 } = useLocaleR42();
    const isDark = variant === 'dark';
    return (
        <footer
            className={`border-t ${isDark ? 'border-white/10 bg-[#0a1628] text-white/80' : 'border-[#0a1628]/10 bg-white text-[#1a3a5c]/80'} px-4 py-6 text-xs sm:px-6`}
            data-testid="legal-footer"
        >
            <div className="mx-auto flex min-w-0 max-w-6xl flex-wrap items-center justify-between gap-3">
                <div className="min-w-0 break-words leading-relaxed">
                    © {new Date().getFullYear()} <span className="font-semibold">{t42("SSA MEDIA LLC")}</span> {t42("· SplashPad is a product of SSA MEDIA LLC.")} </div>
                <div className="flex min-w-0 max-w-full flex-wrap items-center gap-x-4 gap-y-1">
                    <Link to="/blog" className={`sd-focus inline-flex min-h-11 items-center rounded-md py-1 hover:underline ${isDark ? 'text-white' : 'text-[#0a1628]'}`} data-testid="legal-footer-blog-link"> {t42("Blog")} </Link>
                    <Link to="/security" className={`sd-focus inline-flex min-h-11 items-center rounded-md py-1 hover:underline ${isDark ? 'text-white' : 'text-[#0a1628]'}`} data-testid="legal-footer-security-link"> {t42("Security")} </Link>
                    <Link to="/privacy" className={`sd-focus inline-flex min-h-11 items-center rounded-md py-1 hover:underline ${isDark ? 'text-white' : 'text-[#0a1628]'}`} data-testid="legal-footer-privacy-link"> {t42("Privacy Policy")} </Link>
                    <Link to="/terms" className={`sd-focus inline-flex min-h-11 items-center rounded-md py-1 hover:underline ${isDark ? 'text-white' : 'text-[#0a1628]'}`} data-testid="legal-footer-terms-link"> {t42("Terms of Service")} </Link>
                    <Link to="/sms-terms" className={`sd-focus inline-flex min-h-11 items-center rounded-md py-1 hover:underline ${isDark ? 'text-white' : 'text-[#0a1628]'}`} data-testid="legal-footer-sms-link"> {t42("SMS Terms")} </Link>
                    <Link to="/accessibility" className={`sd-focus inline-flex min-h-11 items-center rounded-md py-1 hover:underline ${isDark ? 'text-white' : 'text-[#0a1628]'}`} data-testid="legal-footer-accessibility-link"> {t42("Accessibility")} </Link>
                    <Link to="/privacy/delete-my-data" className={`sd-focus inline-flex min-h-11 items-center rounded-md py-1 hover:underline ${isDark ? 'text-white' : 'text-[#0a1628]'}`} data-testid="legal-footer-privacy-choices-link"> {t42("Your Privacy Choices")} </Link>
                    <a
                        href="mailto:support@splashpad.pro"
                        className={`sd-focus inline-flex min-h-11 items-center rounded-md py-1 hover:underline ${isDark ? 'text-white' : 'text-[#0a1628]'}`}
                        data-testid="legal-footer-contact-link"
                    > {t42("Contact")} </a>
                </div>
            </div>
        </footer>
    );
}

export default LegalFooter;
